export default __webpack_public_path__ + "static/media/graphic-15.cc2ff3b8.png";